import React from 'react';
import { Select, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { SelectTab, SelectWrapper } from '../styles';
import { CustomSelectBox } from '../../../../../CommonComponents/commonStyles';
import { connect } from 'react-redux';
import { selectState } from "../selectors";
let dropDownOptions = [];

const Option = Select.Option;

export class MultiSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: 'large',
      children: this.props.menu,
      optionsAnt: [],
      optionInfo: ['A', 'B', 'C', 'D', 'E', 'F'],
      info: false
    };
    this.OptionInfoHandler = this.OptionInfoHandler.bind(this);
    this.configureOptions = this.configureOptions.bind(this);
  }

  disableInput() {
    
    const selects = document.getElementsByClassName(`ant-select-search__field`);
    for (let el of selects) {
      el.setAttribute(`maxlength`, 0);
      el.setAttribute('cursor', 'unset');
    }
  }
  componentDidMount() {
    this.disableInput();
    let liCount = 0;
    let multiSelectNode = document.querySelector("input[id^='contrActivityMultiSelect']")
    if(multiSelectNode){
      multiSelectNode.setAttribute("id","contributionActivityMutiselectInput")
      multiSelectNode.setAttribute("aria-label","contribution Activity Mutiselect Input")
  }
    if(document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu")[0]){
      liCount = document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu")[0].getElementsByTagName("li").length;
    }
    if(this.props.dropDownValues){
    if(liCount > this.props.dropDownValues.length){
      document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu-item-selected")[0].style.display = "none"
    }
    if(liCount === 2){
      document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown").style.top = "137 !important";
    }
  }
  }
 
  componentDidUpdate(){
    let liCount = 0;
    if(document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu")[0]){
      liCount = document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu")[0].getElementsByTagName("li").length;
    }
    if(this.props.dropDownValues){
    if(liCount > this.props.dropDownValues.length){
      document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu-item-selected")[0].style.display = "none"
    }
    if(liCount === 2){
      document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown").style.top = "137 !important";
    }
  }
  }

  OptionInfoHandler(index) {
    this.setState({ info: true });
  }

  configureOptions = data => {
    let optionsAnt = data;
    let newOption =
      optionsAnt &&
      optionsAnt.map((x, index) => (
        <Option key={index} value={x}>
          <Tooltip overlayClassName="ga-tooltip" placement='right' title={x}>
            {' '}
            {x}{' '}
          </Tooltip>
        </Option>
      ));

    return newOption;
  };

  render() {
    let dropDownOption = this.configureOptions(this.props.dropDownValues);
    let liCount= 0;
    if(document.getElementById("contrActivityMultiSelect") && document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu")[0]){
      liCount = document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu")[0].getElementsByTagName("li").length;
    if(this.props.dropDownValues){
      
      if(liCount > this.props.dropDownValues.length){
        document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown-menu-item-selected")[0].style.display = "none"
      }
      if(liCount === 2){
        document.getElementById("contrActivityMultiSelect").getElementsByClassName("ant-select-dropdown").style.top = "137 !important";
      }
    }
  }
    return (
     
       <SelectWrapper>
        <CustomSelectBox dropdownClassName="advisorSel"
        width="148"
          id="contrActivityMultiSelect"
          mode='tags'
          aria-label="select"
          role={false}
          placeholder='-Select-'
          defaultValue={[]}
          showArrow={true}
          defaultActiveFirstOption={false}
          onChange={this.props.handleDropper}
          style={{ cursor: 'unset', marginRight: '20px' }}
        >
          {dropDownOption}
        </CustomSelectBox>
        </SelectWrapper>
    );
  }
}

MultiSelect.propTypes = {
  dropDownValues: PropTypes.array
}

const mapStateToProps = state => ({
  ...selectState(state.toJS())
});

export default connect(
  mapStateToProps,
  null
)(MultiSelect);